"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedgiftcardsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedgiftcardsm` : '') + (description ? ` desc-brandedgiftcardsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedgiftcardsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedgiftcardsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M.36 5.8a.6.6 0 0 1 .41-.73L15.84.46a.6.6 0 0 1 .75.37l3.03 9.93c.1.3-.09.63-.4.73l-15.08 4.6a.6.6 0 0 1-.75-.37L.36 5.79Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.34 7.1c0-.29.27-.52.6-.52H19.4c.32 0 .59.23.59.53v9.5c0 .3-.27.54-.6.54H3.95c-.33 0-.6-.24-.6-.53V7.1Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.34 12.34v-1.28H20v1.28H3.34Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.83 6.58H9.1v10.57H7.83V6.58Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.02 8.85c.62-.54 1.72-.45 2.46.22.53.48.77 1.7.87 2.36l.05.04.05-.04c.1-.67.34-1.88.87-2.36.74-.66 1.84-.76 2.45-.22.62.55.5 1.54-.24 2.21-.44.4-1.48.62-2.24.72l1.17.98-.84.7L8.4 11.9l-1.66 2.36-1.05-.96 1.82-1.51c-.76-.11-1.8-.33-2.25-.73-.74-.67-.85-1.66-.24-2.2Zm6.2 1.51c.39-.34.44-.84.13-1.12-.31-.28-.87-.23-1.26.1-.38.35-.47 1.45-.47 1.45s1.22-.08 1.6-.43Zm-4.05.42s-.08-1.1-.47-1.43c-.38-.34-.94-.4-1.25-.11-.31.28-.26.78.12 1.12.38.34 1.6.42 1.6.42Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandedgiftcardsm;